const initialState = {};

const featureFlags = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default featureFlags;
